import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { translate as t } from '../../lib/I18n';
import OrderStore from '../../stores/OrderStore';
import OrderActions from '../../actions/OrderActions';
import ModalActions from '../../actions/ModalActions';
import { GlobalModals } from '../../constants/AppConstants';

import BaseModal from '../general/BaseModal';
import PureRenderComponent from '../PureRenderComponent';

class InteropErrorModal extends PureRenderComponent {

    static propTypes = {
        router: PropTypes.any.isRequired
    };

    state = {
        loading: true
    };

    UNSAFE_componentWillMount () {
        _.defer(() => {
            const order = OrderStore.getCurrent();
            OrderActions.refresh(order).then(() => {
                this.setState({ loading: false });
            });
        });
    }

    _closeModal () {
        ModalActions.close(GlobalModals.INTEROP_ERROR);
    }

    _clearBasket = () => {
        OrderActions.clearBasket(OrderStore.getCurrent());
        this._closeModal();
    };

    render () {
        return (
            <BaseModal className="modal--sm"
                titleText="order.interopErrorModal.heading"
                onClose={ this._clearBasket }
                hideContinue
            >
                <div className="vertical-align-parent full-height">
                    <div className="b-alert b-alert--danger margin-top margin-bottom vertical-align text-center">
                        <p>{ t('order.interopError.message') }</p>
                        <p>{ t('order.interopError.messageHelp') }</p>
                    </div>
                </div>
            </BaseModal>
        );
    }
}

export default InteropErrorModal;
